import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
} from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';

import {
  ButtonModule,
  DIALOG_DATA,
  DialogRef,
  IconModule,
  SimpleInputModule,
} from '@hglobal/fin-ui';
import { FormBuilder } from '@ngneat/reactive-forms';
import { TranslateModule } from '@ngx-translate/core';

import { LogoComponent } from '@iw/common';
import { AuthStore, Enable2FAData } from '@iw/core/auth-store';
import { environment } from '@iw/environment';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    IconModule,
    SimpleInputModule,
    LogoComponent,
  ],
  selector: 'iw-tfa-reset',
  templateUrl: './tfa-reset.component.html',
  styleUrls: ['./tfa-reset.component.scss', '../signin-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TfaResetComponent {
  readonly #fb = inject(FormBuilder);
  readonly #store = inject(AuthStore);
  readonly #dialogRef = inject(DialogRef);
  readonly data = inject<Enable2FAData & { token: string }>(DIALOG_DATA, {
    optional: true,
  });

  supportLink = environment.supportLink;
  token = this.data?.token;
  isLoading = false;

  form = this.#fb.group({
    recoveryCode: ['', [Validators.required]],
  });
  errorDictionary: Record<string, string> = {
    apiValidation: 'errors.invalid_recovery_code',
  };

  readonly resetCodeSuccessEffect = effect(() => {
    const verified = this.#store.isResetCodeSuccess();
    if (verified) {
      this.isLoading = false;
      this.#dialogRef.close();
    }
  });

  readonly resetCodeFailedEffect = effect(() => {
    const error = this.#store.resetCodeError();
    if (error) {
      this.isLoading = false;
      error?.code === 'invalid_recovery_code' &&
        this.form.controls.recoveryCode.setErrors({ apiValidation: true });
    }
  });

  reset(): void {
    this.isLoading = true;
    this.#store.resetCode({ ...this.form.value });
  }
}
